import ScoreIcon from './ScoreIcon';
import SliderInput from './SliderInput';

function Slider({
    value,
    setValue,
    getColorForScore,
    getIconForScore
}) {
    const handleSliderChange = (e) => {
        const value = parseFloat(e.target.value);
        setValue(value);
    };
    return (
        <div style={{ position: "relative" }}>
            <SliderInput
                value={value}
                handleSliderChange={handleSliderChange}
                getColorForScore={getColorForScore}
            />

            <div
                style={{
                    position: "absolute",
                    left: "15rem",
                    top: 0,
                    height: "100%",
                    display: "flex",
                    flexDirection: "column-reverse",
                    justifyContent: "space-between",
                }}
            >
                {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((num) => {
                    const isActive = Math.round(value) === num;
                    return (
                        <div
                            key={num}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "0.5rem",
                                cursor: "pointer",
                                transition: "transform 0.2s ease",
                            }}
                            onClick={() => setValue(num)}
                            onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.25)")}
                            onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                        >
                            <div
                                style={{
                                    fontSize: isActive ? "1.25rem" : "1rem",
                                    transition: "all 0.2s ease",
                                    color: isActive ? getColorForScore(value) : "#9ca3af"
                                }}
                            >
                                <ScoreIcon score={num} getIconForScore={getIconForScore} />
                            </div>

                            <span
                                style={{
                                    fontSize: "0.75rem",
                                    fontWeight: 500,
                                    transition: "color 0.2s ease",
                                    color: isActive ? getColorForScore(value) : "#6b7280"
                                }}
                            >
                                {num}
                            </span>
                        </div>
                    );
                })}
            </div>
        </div>
    )
}

export default Slider;